<template>
<div>
  <div class="content">

    <van-form @submit="submitJsy">
      <van-cell-group >
        <div class="upload-box">
          <h2 class="upload-box__title">上传电子运单</h2>
          <van-uploader v-model="indzydimage" :max-size="10240 * 1024" @oversize="onOversize" :before-read="beforeRead" :after-read="afterReadFile" :before-delete="deleteUploadImg"></van-uploader>
        </div>
      </van-cell-group>
      <div style="margin: 1rem;">
        <van-button round block type="info" native-type="submit" class="addBtn" @loading="loadingBtn">
          保存
        </van-button>
      </div>
    </van-form>
  </div>
  <Tabbar></Tabbar>
</div>
</template>

<script>
import api from '@/fetch/api';
import {
  Dialog,
  Toast
} from 'vant'
import Compressor from 'compressorjs';
import Tabbar from '../Public/tabbarTpl.vue'
export default {
  components: {
    Tabbar
  },
  data() {
    return {
      fileList: [],
      id: '',
      uploadLoading: false,
      uploadDisabled: false,
      dzydbh: "",
      dzydpz: "",
      dzydsl: 0,
      dzydtyr: "",
      loadingBtn: false,

      indzydurl: "",
      indzydimage: [],
      indzydurlArr: [],
      indzydimageArr: [],
    };
  },
  created() {
    document.title = "上传电子运单";
    var id = this.$route.params.id;
    this.$data.id = id;
  },
  methods: {
    beforeRead(file) {
      let quality = 0.6;
      if (file.size < 4 * 1024 * 1024) {
        quality = 0.9;
      } else if (file.size >= 4 * 1024 * 1024 && file.size < 8 * 1024 * 1024) {
        quality = 0.8;
      } else {
        quality = 0.6;
      }
      return new Promise((resolve) => {
        // compressorjs 默认开启 checkOrientation 选项
        // 会将图片修正为正确方向
        new Compressor(file, {
          quality: quality,
          success(result) {
            let newfile = new File([result], file.name, {
              type: file.type
            })
            resolve(newfile)
          },
          error(err) {
            console.log('图片压缩失败---->>>>>', err)
          }
        })

      });

    },

    submitJsy() {
      var that = this;
      var yyid = this.$data.id;

      var indzydurl = "";
      var indzydurlArr = that.indzydurlArr;
      console.log(indzydurlArr);
      if (indzydurlArr.length > 0) {
        for (var k = 0; k < indzydurlArr.length; k++) {
          indzydurl += indzydurlArr[k] + ",";
        }
        //去掉最后一个逗号(如果不需要去掉，就不用写)
        if (indzydurl.length > 0) {
          indzydurl = indzydurl.substr(0, indzydurl.length - 1);
        }
      } else {
        Toast.fail('请上传电子运单');
        return false;
      }

      that.$data.loadingBtn = true;

      var formData = new FormData();
      formData.append('yyid', yyid);
      formData.append('indzydurl', indzydurl);
console.log(formData);
      api.submitdzyd(formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          Dialog.alert({
            message: '信息保存成功',
          }).then(() => {
            that.$router.push({
              name: 'orderdetail',
              params: {
                id: yyid
              }
            });
          });
        } else {
          Dialog.alert({
            message: resData.message,
          }).then(() => {

          });
        }
      }).catch(function() {
        that.$data.loadingBtn = false;
        Toast.fail('连接失败，请刷新页面');

      });
    },
    onOversize(file) {
      console.log(file);
      Toast('文件大小不能超过 10Mb');
    },
    afterReadFile(file) {
      var that = this;
      var formData = new FormData();
      var id = that.$data.id;
      const weburl = that.GLOBAL.weburl;
      formData.append('yyid', id);
      formData.append('dzydpics', file.file);
      api.postupdzydnew(formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data.dzydurl;
          var indzydimageArr = that.indzydimageArr;
          var indzydurlArr = that.indzydurlArr;
          var imageDataArr = imageData.split(',');
          for (var i = 0; i < imageDataArr.length; i++) {
            if (indzydimageArr.length > 0) {
              indzydimageArr.push({
                'url': weburl + '/' + imageDataArr[i]
              });
              indzydurlArr.push(imageDataArr[i]);
            } else {
              indzydimageArr = imageDataArr[i] ? [{
                url: weburl + '/' + imageDataArr[i]
              }] : [];
              indzydurlArr = imageDataArr[i] ? [imageDataArr[i]] : [];
            }
          }

          that.indzydimage = that.indzydimageArr = indzydimageArr;
          that.indzydurlArr = indzydurlArr;

        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('连接失败，请刷新页面');
      });

    },
    deleteUploadImg(file) {
      var that = this;
      const weburl = that.GLOBAL.weburl;
      var indzydimageArr = that.indzydimageArr;
      var indzydimageArrNew = [];
      var indzydurlArrNew = [];
      for (var i = 0; i < indzydimageArr.length; i++) {
        if (indzydimageArr[i].url != file.url) {
          indzydimageArrNew.push(indzydimageArr[i]);
          var path = indzydimageArr[i].url.replace(weburl, '');
          indzydurlArrNew.push(path);
        }
      }
      that.indzydimage = that.indzydimageArr = indzydimageArrNew;
      that.indzydurlArr = indzydurlArrNew;
    },
    uploadButton() {
      var that = this;
      var formData = that.formData;

      if (formData == undefined) {
        Dialog({
          message: '请上传图片'
        });
      } else {
        that.$data.uploadDisabled = true;
        that.$data.uploadLoading = true;

        api.postupdzyd(formData).then(function(resData) {
          var res = JSON.parse(resData);

          that.$data.uploadDisabled = false;
          that.$data.uploadLoading = false;

          if (res.respCode == "0") {
            var yyid = that.$data.id;
            Dialog.alert({
              message: '上传成功',
            }).then(() => {
              that.$router.push({
                name: 'orderdetail',
                params: {
                  id: yyid
                }
              });
            });
          }

        }).catch(function(err) {
          console.log(err);
          that.$data.loadingBtn = false;
          Toast.fail('连接失败，请刷新页面');
        });
      }

    }
  },
};
</script>
<style lang="scss" scoped>
.content {
    margin-top: 1rem;
    .addBtn {
        background: #316892;
    }
    .upload-box
    {
      margin: 1rem;
      padding-bottom: 1rem;
      .upload-box__title
      {
        padding:1rem 0;
      }
    }
}
.preview-cover {
    position: absolute;
    bottom: 0;
    box-sizing: border-box;
    width: 100%;
    padding: 4px;
    color: #fff;
    font-size: 12px;
    text-align: center;
    background: rgba(0, 0, 0, 0.3);
}

</style>
